<template>
  <div>
    <div>
      <v-card style="position: relative">
        <v-card-title class="display-1">
          Products

          <v-spacer></v-spacer>

          <v-text-field
            append-icon="search"
            label="Search"
            v-model="search"
            class="mr-2"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :items="products"
          :headers="headers"
          :footer-props="{'items-per-page-options': [15, 30, 50, 100]}"
          :search="search"
          class="clickable"
          mobile-breakpoint="0"
        >
          <template v-slot:item="{ item }">
            <tr :key="item.id" @click="click(item)">
              <td class="g-d-flex align-center justify-center">
                <div class="product__image">
                  <img :src="getProductThumbnail(item)" alt="" @error.once="thumbnailFallback($event, item)">
                </div>
              </td>
              <td>{{ !item.sku || item.id === item.sku ? '-' : item.sku }}</td>
              <td>
                {{ item.name_zh_hk }}
              </td>
              <td>{{ item.sale.count || '-' }}</td>
              <td>
                {{ item.sale.amount ? item.sale.amount.toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : '-' }}
              </td>
              <td v-if="withActions && matchRoles(['product_management'])">
                <router-link style="text-decoration: none" :to="{ name: 'SlottingProductSales', params: { id: item.id }}" target="_blank" rel="opener" @click.native.stop="" class="icon-link">
                  <v-icon small color="primary" class="mr-2">mdi-open-in-new</v-icon>
                </router-link>

                <v-icon small color="error" @click.native.stop="remove(item)">delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-if="showCreateProduct" v-model="showCreateProduct" persistent>
      <product-detail create @close="closeCreateProduct" @created="createdProduct" ></product-detail>
    </v-dialog>

    <v-dialog v-if="false && showCreateCombo" v-model="showCreateCombo" persistent>
      <product-combo create @close="closeCreateCombo" @created="createdProduct" ></product-combo>
    </v-dialog>

    <v-speed-dial
      fixed
      :top="false"
      :bottom="true"
      :right="true"
      direction="top"
      :open-on-hover="true"
      transition="slide-y-reverse-transition"
      v-if="matchRoles(['product_management'])"
    >
      <v-btn slot="activator" color="blue darken-2" dark fab >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn dark fab small color="pink" @click="showCreateProduct = !showCreateProduct" >
        <v-icon>mdi-cube</v-icon>
      </v-btn>
      <v-btn v-if="showCreateCombo" dark fab small color="green" @click="showCreateCombo = !showCreateCombo" >
        <v-icon>mdi-cube-unfolded</v-icon>
      </v-btn>
    </v-speed-dial>

    <product-delete
      v-if="selectedForDelete !== null"
      :product="selectedForDelete"
      @done="doneDelete"
      @cancel="closeDelete"
    ></product-delete>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import ProductDetail from '@/components/Product/Detail'
  import ProductCombo from '@/components/Product/Combo'
  import ProductDelete from '@/components/Product/Delete'

  import productMixin from '@/mixins/product'

  export default {
    name: 'product-list',

    props: {
      productComponent: String,
      productService: Object,
      withActions: {
        type: Boolean,
        default: false
      },
    },

    components: {
      ProductDetail,
      ProductCombo,
      ProductDelete
    },

    mixins: [
      productMixin,
    ],

    data () {
      return {
        search: null,

        loading: false,

        products: [],

        headers: [
          { text: 'Thumbnail', value: 'thumbnail', align: 'center', sortable: false },
          { text: 'SKU', value: 'sku', align: 'left' },
          { text: 'Name', value: 'name_zh_hk', align: 'left' },
          // { text: 'Combo', value: 'is_product_combo', align: 'left' },
          { text: '30-day Tx', value: 'sale.count', align: 'left' },
          { text: '30-day Sales', value: 'sale.amount', align: 'left' },
        ],

        showFab: false,

        showCreateProduct: false,

        // todo: support advance product management role
        showCreateCombo: false,

        selectedForDelete: null
      }
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),
    },

    created () {
      if (this.withActions && this.matchRoles(['product_management'])) {
        this.headers.push({ text: 'Action', value: 'sku', align: 'left' })
      }
      this.updateTable()
      this.$store.commit('UPDATE_TITLE', 'My Products')
    },

    mounted () {
      setTimeout(() => {
        this.showFab = true
      }, 400)
    },

    beforeRouteLeave (to, from, next) {
      this.showFab = false
      next()
    },

    methods: {
      updateTable () {
        this.loading = true

        this.productService
          .getAll()
          .then(({ data }) => {
            this.products = data.data
          })
          .finally(() => {
            this.loading = false
          })
      },

      click (item) {
        this.$router.push({
          name: this.productComponent,
          params: {
            'id': item.id
          }
        })
      },

      closeCreateProduct () {
        this.showCreateProduct = false
      },

      closeCreateCombo () {
        this.showCreateCombo = false
      },

      createdProduct (product) {
        this.products.push(product)
        this.closeCreateProduct()
        this.closeCreateCombo()
      },

      remove (product) {
        this.selectedForDelete = product
      },

      closeDelete () {
        this.selectedForDelete = null
      },

      doneDelete () {
        this.products = []
        this.closeDelete()
        this.updateTable()
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .product__image
    width: 50px
    height: 50px

    img
      width: 100%
      height: 100%
      object-fit: contain
</style>



// WEBPACK FOOTER //
// src/components/Common/Product/ProductList.vue